import React, { Component } from "react";
import { Button, Modal, PageHeader, FormGroup, InputGroup, FormControl, ListGroup, ListGroupItem } from "react-bootstrap";
import { Link, Routes }            from 'react-router-dom'
import { FontAwesomeIcon }         from '@fortawesome/react-fontawesome'
import LoaderButton                from "../../components/LoaderButton";
import FooterLoadingBar            from "../../components/utils/FooterLoadingBar";
import SortDropdownMembersBasicMenu from "../../components/utils/SortDropdownMembersBasicMenu";
import RenderLander                from "../../components/utils/RenderLander";
import { handleGoToURL}            from "../../utils/URL";
import uniqueId                    from 'lodash/uniqueId';
import { API, Storage }            from "aws-amplify";
import { Colors }                  from "../../utils/Colors";
import ModalAlert                  from "../../components/modal/ModalAlert";
import { invokeGetClientsListAll,
         invokeSetAddClientToTrainerList
       } from "../../utils/AwsInvoke";
import "../../css/client/ClientListAll.css";
import "../../css/form/Btn.css";
import "../../css/modal/ModalBasics.css";
import checkmark_green from '../../images/utils/checkmark_green.png';
import checkmark_gray  from '../../images/utils/checkmark_gray.png';

// uuidv1() = timestamp | uuidv4() = rnadom
const uuidv1 = require('uuid/v1');

export default class ClientList extends Component {
    constructor(props) {
        super(props);

        var search_term = `${this.props.match.params.search_term}`;
        var globalTrainerOnTrialPeriod = localStorage.getItem('globalTrainerOnTrialPeriod');
        if(search_term === "&") search_term = "";

        this.state = {
              isLoading: true, // default is true
              numberOfRows: 200,
              company_id: "",
              searchMsg: "",
              searchTerm: search_term,
              showLoadingBar:"none",
              sortBy: 1, // default sort by Name Asc
              pageOverlay: "none",
              trainerOnTrialPeriod: globalTrainerOnTrialPeriod,
              modalAlertTitleText: "",
              modalAlertBodyText:  "",
              showModalAlert:      false, // true | false
              alertAction:         "",
        };
    }

    componentDidMount() {
        var that = this;
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            this.getMemberList();
        } catch (e) {
            alert(e);
        }
    }

    componentDidUpdate(prevProps) {

        var search_term = `${this.props.match.params.search_term}`;
        if(search_term === "&") search_term = "";

        if (this.state.searchTerm !== search_term) {
            this.setState({
                searchTerm: search_term
            }, function(){
                this.getMemberList();
            })
        }
    }

    getMemberList = async event => {

        var number_of_rows = this.state.numberOfRows;
        this.setState({
            showLoadingBar: "inline"
        })

        //// If user searched for a member and then hits the back button,
        //// take the user back to the search results page with the search term
        var search_term = this.state.searchTerm;
        var sort_by     = this.state.sortBy;
        var company_id  = this.props.globalCompanyId;

        // SortBy: name ASC, 2: name DESC

        if(search_term != "" && search_term != "&") {
            //this.searchMembers(number_of_rows, sort_by); // search for existing keyword
        } else {
            search_term = "";
        }

        const results = await invokeGetClientsListAll(number_of_rows, sort_by, company_id, search_term.toLowerCase());

        if(results) {
            //console.log("results.length: " + results.search_lgth);

            this.setState({
                members: results,
                totalMembers: results.search_lgth,
                isLoading: false,
                showLoadingBar: "none"
            });
        } else
            this.setState({ isLoading: false, showLoadingBar: "none" })
    }

    clearSearchField = () => {
        // RESET URL
        this.props.history.replace("/client/listAll/&")

        this.setState({
            searchTerm: "", // reset search term if resetting member list
        })
    }

    searchMembers = async () => {
        var search_term = this.state.searchTerm;

        if(this.searchInput != undefined) {
            search_term = this.searchInput.value;

            if(search_term.length === 0) search_term = "&";

            this.props.history.replace("/client/listAll/"+search_term)

            //// RESET Search Textfield
            if(search_term === "&") {
                this.setState({
                    searchTerm: "", // reset search term if resetting member list
                    searchMsg: ""   // clear search message
                }, function () {
                    this.getMemberList();
                })
                return
            } else {
                this.setState({
                    searchTerm: search_term, // reset search term if resetting member list
                    searchMsg: ""   // clear search message
                }, function () {
                    this.getMemberList();
                })
            }
        } else {

                var company_id     = this.state.company_id;
                var sort_by        = this.state.sortBy;
                var number_of_rows = this.state.numberOfRows;

                const results = await invokeGetClientsListAll(number_of_rows, sort_by, company_id, search_term.toLowerCase());

                if(results) {
                    this.setState({
                        members: results,
                        searchTerm: search_term,
                        // searchMsg: "You have "+results.search_lgth+ " results when searching for '" + search_term + "'.",
                        isLoading: false,
                        showLoadingBar: "none"
                    });
                } else {
                    this.setState({
                        isLoading: false,
                        showLoadingBar: "none"
                    });
                }
        }
    }

    sortResults = (sort) => {
        this.setState({
            sortBy: sort,
            members: null // reset members object otherwise the members list will re-render multiple times
        }, function(){
            this.getMemberList();
        })
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13)
            this.searchMembers();
    }

    async addClientToTrainerList (client_id, client_name, event) {

        event.preventDefault();

        if(client_id != "undefined") {
                this.setState({
                    loadingData: "Adding member to list ... ",
                    showLoadingBar: "inline"
                })
                const results = await invokeSetAddClientToTrainerList(client_id);

                if(results) {
                    this.setState({
                        searchMsg: client_name + " added as a member",
                        showLoadingBar: "none"
                    }, function(){
                        this.getMemberList();
                    })

                } else
                    this.setState({
                        showLoadingBar: "none"
                    })
        }
    }

    resetSearch = () =>  {
        this.props.history.replace("/client/listAll/&")

        //// RESET Search Textfield
            this.setState({
                searchTerm: "", // reset search term if resetting member list
                searchMsg: ""   // clear search message
            }, function () {
                this.getMemberList();
            })
    }

    async getAttachment (photo_id) {
        if(photo_id != null) {
            var attachmentURL = await Storage.vault.get(photo_id);
        }
    }

    renderMembersList(members) {

          var photo_url;
          var search_msg     = "";
          var total_members  = this.state.totalMembers;
          var tmp_search_msg = this.state.searchMsg;
          var members_label  = " Total members";
          var reset_btn = <Button className = "btnClientAddNew"
                                  onClick={this.resetSearch.bind()}>
                              Reset Results
                          </Button>
          var search_term = this.state.searchTerm;
          if(search_term === "") reset_btn = "";
          if(total_members == 1) members_label = "Total member";

          search_msg = <div key={uniqueId()} className="exerciseHeaderButtons">
                            <span className="pull-left"
                                  style={{position:"relative", left:"10px"}}
                                  >
                                  { /*tmp_search_msg*/ }
                                  <span style={{position:"relative", top:9, left: 0}}>
                                      { total_members } {members_label}
                                  </span>
                                  <span style={{position:"absolute", top:2, left: 147}}>
                                      { reset_btn }
                                  </span>
                            </span>

                            <span className="pull-right">
                                <SortDropdownMembersBasicMenu sortResults={this.sortResults.bind(this)} />
                            </span>
                       </div>

            if(members != null) {
                  return [{}].concat(members.first_name).map(
                    (member, i) =>
                      i !== 0 ?
                              <div key={uniqueId()}
                                   className="grid exerciseListGrid"
                                   href= {"/client/detail/"+members.id[i-1]}
                                   onClick={(e) => handleGoToURL(e, this, "/client/detail/"+members.id[i-1])}>
                                        <span className="clientListRowLeft">
                                                <span className="clientListSingleRowThumb">
                                                    { member.charAt(0) }
                                                    { /* get profile photo this.getAttachment(members.photo_id[i-1])*/ }
                                                </span>
                                        </span>
                                        <span   className="clientListRowMiddleLeft">
                                              <span className="clientListNameSingleRow">
                                                  { member + " " + (members.last_name[i-1] == null ? '' : members.last_name[i-1]) }
                                                  { /*}<span className="clientListDateAdded">Created: { (new Date(members.date[i-1])).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) }</span>*/ }
                                              </span>

                                        </span>
                                        { /*<span className="clientListRowMiddleCenter" style={{position:"absolute", top:18, left:300,  border:"0px solid #000", width:20}}>
                                            { /*members.phone[i-1]* / }

                                        </span>
                                        }<span className="clientListRowMiddleRigh" style={{border:"0px solid #000", width:0}}>

                                        </span>*/ }
                                        <span className="clientListRowRight" style={{position:"absolute", top:15, right:80, zIndex:1000, backgroundColor: "transparent"}}>
                                            { members.email[i-1] }
                                                {/* friend member: works fine temp removed 10/14 } */ }

                                                { /*}<span   className="clientListEditCol"
                                                        href= {"/client/edit/"+members.id[i-1]}
                                                        onClick={(e) => handleGoToURL(e, this, "/client/detail/"+members.id[i-1])}
                                                        Edit
                                                </span>* / }
                                                <span className="clientListDeleteCol pullRight"
                                                      onClick={(e) => this.handleDeleteMember(e, members.id[i-1], member + " " + members.last_name[i-1])}>
                                                    <span className="glyphicon glyphicon-remove-circle glyphiconDeleteClientBtn" style={{color: Colors.delete_button_bg }} />
                                                </span>*/ }
                                        </span>
                                        <span className="clientListEditCol">
                                                    { members.member[i-1] === "match" ? <span className="glyphicon glyphicon-user glyphiconAddClientBtn" style={{right:"-7px", color:"#ccc", fontSize:"30px"}}/> : <span className="glyphicon glyphicon-plus-sign glyphiconAddClientBtn" style={{color: Colors.add_button_bg}} onClick={this.addClientToTrainerList.bind(this, members.id[i-1], member + " " + members.last_name[i-1])} />  }
                                        </span>
                            </div>

                            :
                            <span key={uniqueId()} >
                                <div className="exerciseHeaderSearchBar">
                                    <span>
                                        <FormGroup>
                                           <InputGroup>
                                             <FormControl key = {uniqueId()}
                                                          type="text"
                                                          placeholder=""
                                                          defaultValue={this.state.searchTerm}
                                                          inputRef={ref => { this.searchInput = ref; }}
                                                          onKeyPress={this.handleKeyPress}
                                                      />

                                               <span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                                     onClick={() => this.clearSearchField()}
                                               />
                                               <InputGroup.Button>
                                                 <Button style={{ display:"inline-block", height:"34px",backgroundColor: Colors.search_button_bg, color:"white", borderRadiusInputTopRight: "5px" }} onClick={() => this.searchMembers()}>Search</Button>
                                               </InputGroup.Button>
                                           </InputGroup>
                                         </FormGroup>
                                  </span>
                              </div>
                              { search_msg }

                              { i === 0 && members.search_lgth < 1 ?
                                    <ListGroupItem className="exerciseListGrid" style={{height:400}}>
                                        <br/>
                                    You currently have 0 members.
                                    </ListGroupItem>

                                : null }
                          </span>
                  );
             }
    }

    //// Temp solution for mobile browser back button issue described above;
    //// works great but having issues with the popup confirm box
    /*handleNewDeleteMember = event => {
        event.preventDefault();
        this.props.history.push(event.currentTarget.getAttribute("href"));
    }*/

    getNext100Results = () => {
        var tmp_rows = this.state.numberOfRows;
        tmp_rows = tmp_rows + 100;

        this.setState({
            numberOfRows: tmp_rows
        }, function(){
            this.getMemberList();
        })
    }

    handleNoMoreMembers = () => {

        this.setState({
            modalAlertTitleText: "Add New Member",
            modalAlertBodyText:  "Sorry, as a trial member you're not allowed to add anymore clients.",
            showModalAlert:      true,
            alertObject:         "", // used to delete programs; not req'd
            alertAction:         ""
        })
    }

    renderPrograms() {
        var next_100;
        var total_members    = this.state.totalMembers;
        var trainer_on_trial = this.state.trainerOnTrialPeriod;
        var add_new_member = <Button className = "btnClientAddNew"
                                    style     = {{ position:"relative", top:0}}
                                    onClick   = {(e) => handleGoToURL(e, this, "/client/new")}>
                                Add New Member
                             </Button>

        ////  If trainer is on a TRIAL PERIOD, do not allow more than 3 members to be added  //
        if(total_members > 2 && trainer_on_trial == "true")
                add_new_member = <Button className = "btnClientAddNew"
                                         style     = {{ position:"relative", top:0}}
                                         onClick   = {(e) => this.handleNoMoreMembers()}>
                                        Add New Member
                                 </Button>

        //if(!this.state.isLoading) // next_100 = <span style={{display:"inline-block", width:"100%", textAlign:"center", fontSize:"18px", cursor:"pointer"}} onClick={() => this.getNext100Results()}>Next 100 results >></span>

        if(this.state.searchMsg != "") next_100 = ""; // if user is searching for a member, hide "next 100 results" msg

        return (
              <div className="programs">
                <PageHeader>
                        <span style={{width:"220px", position:"relative", top:6}}>
                            <span className="glyphicon glyphicon-user" style={{ position:"relative", top:2, fontSize: '.9em', color: Colors.primary_color, paddingRight:"16px" }}/>
                            Members
                        </span>
                        <span className="pull-right" style={{ position:"relative", top: -3, right: 12}}>
                            { add_new_member }
                        </span>
                </PageHeader>

                <ListGroup style={{display: "inline-block"}}>
                    {!this.state.isLoading && this.renderMembersList(this.state.members)}
                </ListGroup>
                { next_100 }
                <br/><br/><br/><br/>
              </div>
        );
    }

    render() {
        let closeModalAlert           = () => this.setState({ showModalAlert: false }); //close simple modal window

        return (
              <div className="ProgramList">
                {this.props.isAuthenticated ? this.renderPrograms() : <RenderLander />}

                <FooterLoadingBar text={"Retrieving Members ..."}
                                  showLoadingBar={this.state.showLoadingBar}/>

                  {this.state.showModalAlert ?
                      <ModalAlert
                          onHide         = {closeModalAlert}
                          //alertFunction  = {this.alertFunction}     // custom function to call within modal
                          alertAction    = {this.state.alertAction} // flag used for above function
                          alertObject    = {this.state.alertObject} // vars used for above function
                          showModalAlert = {this.state.showModalAlert}
                          messageTitle   = {this.state.modalAlertTitleText}
                          messageBody    = {this.state.modalAlertBodyText}
                      />
                  : null}
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/client/ClientList.js